export async function criarGoogleForms(questoes, titulo) {
    try {
        const formResponse = await gapi.client.forms.forms.create({
            info: {
                title: titulo,
                documentTitle: titulo
            }
        });
        const formId = formResponse.result.formId;

        const requests = [];
        let index = 0;

        requests.push(
            {
                updateSettings: {
                    settings: {
                        quizSettings: {
                            isQuiz: true,
                        },
                    },
                    updateMask: 'quizSettings.isQuiz',
                },
            },
        )
        // Adiciona um campo para nome
        requests.push({
            createItem: {
                item: {
                    title: 'Nome',
                    description: '',
                    questionItem: {
                        question: {
                            textQuestion: {
                                paragraph: false
                            },
                            required: true
                        }
                    }
                },
                location: {
                    index: index
                }
            }
        });
        index += 1;

        // adiciona um campo para turma
        requests.push({
            createItem: {
                item: {
                    title: 'Turma',
                    description: '',
                    questionItem: {
                        question: {
                            textQuestion: {
                                paragraph: false
                            },
                            required: true
                        }
                    }
                },
                location: {
                    index: index
                }
            }
        });
        index += 1;

        // insere as questões
        questoes.forEach((questao, indexQuestao) => {
            // adicionar títúlo da questão
            // verificar se questao.texto tem algum conteúdo e inserir um texto abaixo do título
            requests.push({
                createItem: {
                    item: {
                        title: `Questão ${indexQuestao + 1}`,
                        description: questao.texto,
                        textItem: {}
                    },
                    location: {
                        index: index
                    }
                }
            })
            index += 1;


            // se tem imagem, insere a imagem
            if (questao.imagem !== '' && questao.imagem !== undefined && questao.imagem !== null) {
                requests.push({
                    createItem: {
                        item: {
                            imageItem: {
                                image: {
                                    altText: '',
                                    properties: {
                                        alignment: 'CENTER',
                                        width: 740
                                    },
                                    sourceUri: questao.imagem
                                }
                            }
                        },
                        location: {
                            index: index
                        }
                    }
                })

                index += 1;
            }

            // verifica o tipo de questão com base no fato de ter algo na alternativa A. Se tem, é do tipo multipla escolha RADIO. Se não tem, é dissertativa
            if (questao.a !== '' && questao.a !== undefined && questao.a !== null) {
                let alternativaCorreta = defineAlternativaCorreta(questao);
                requests.push({
                    createItem: {
                        item: {
                            title: questao.pergunta,
                            questionItem: {
                                question: {
                                    required: true,
                                    grading: {
                                        pointValue: 1,
                                        correctAnswers: {
                                            answers: [{ value: alternativaCorreta }]
                                        }
                                    },
                                    choiceQuestion: {
                                        options: defineListaDeAlternativas(questao),
                                        type: 'RADIO',
                                        shuffle: true
                                    }
                                }
                            }
                        },
                        location: {
                            index: index
                        }
                    }
                })

                index += 1;
            }else{
                requests.push({
                    createItem: {
                        item: {
                            title: questao.pergunta,
                            questionItem: {
                                question: {
                                    required: true,
                                    grading: {
                                        pointValue: 1,
                                    },
                                    textQuestion: { paragraph: true }
                                }
                            }
                        },
                        location: {
                            index: index
                        }
                    }
                })

                index += 1;
            }
        });
 

        await gapi.client.forms.forms.batchUpdate({
            formId: formId,
            requests: requests
        });

        return {status: 'sucesso', formId: formId};

    } catch (error) {
        console.log(error);
        return { status: 'erro', erro: error.result.error.message };
    }
}


function defineAlternativaCorreta(questao) {
    if (questao.gabarito.toLowerCase() === 'a') {
        return questao.a;
    }

    if (questao.gabarito.toLowerCase() === 'b') {
        return questao.b;
    }

    if (questao.gabarito.toLowerCase() === 'c') {
        return questao.c;
    }

    if (questao.gabarito.toLowerCase() === 'd') {
        return questao.d;
    }

    if (questao.gabarto.toLowerCase() === 'e') {
        return questao.e;
    }
}

function defineListaDeAlternativas(questao) {
    const alternativas = []
    if (questao.a !== '' && questao.a !== undefined && questao.a !== null) {
        alternativas.push({ value: questao.a });
    }

    if (questao.b !== '' && questao.b !== undefined && questao.b !== null) {
        alternativas.push({ value: questao.b });
    }

    if (questao.c !== '' && questao.c !== undefined && questao.c !== null) {
        alternativas.push({ value: questao.c });
    }

    if (questao.d !== '' && questao.d !== undefined && questao.d !== null) {
        alternativas.push({ value: questao.d });
    }

    if (questao.e !== '' && questao.e !== undefined && questao.e !== null) {
        alternativas.push({ value: questao.e });
    }

    return alternativas;
}

